<template>
  <div>
    <v-form v-model="valid" ref="mainForm">
      <ressource code="service-reference-choix-employeurs"></ressource>
      <v-checkbox
        class="list_counter_validator my-4 p-0"
        :input-value="hasEmployeursInscrits"
        :rules="[(v) => !!v || 'Veuillez sélectionner au moins un bureau.']"
      ></v-checkbox>
      <v-checkbox
        class="list_counter_validator my-4 p-0"
        :input-value="hasNombreEmployeursInscritsConforme"
        :rules="[(v) => !!v || `Votre abonnement inclut l’inscription de ${sas.nombreEmploisReferencesInitial} bureau${sas.nombreEmploisReferencesInitial > 1 ? 'x' : ''} en pratique privée au service de référence. Veuillez sélectionner en conséquence.`]"
      ></v-checkbox>
      <emplois-references
        :sas="sas"
        :valids="validsEmploisReferences"
        ref="dataIterator_emploisReferences"
      ></emplois-references>
      <opq-case
        code="page-personnelle"
        v-model="sasServiceDeReference.sAbonnerALaPagePersonnelle"
        optional
        disabled
      ></opq-case>
      <opq-text-field
        code="service-reference-courriel"
        is-email
        v-model="sasServiceDeReference.courrielServiceReference"
        optional
      ></opq-text-field>
      <opq-catalogue
        code="service-reference-mandat"
        v-model="sasServiceDeReference.mandatsAcceptes"
        optional
        multiple
      ></opq-catalogue>
      <div>
        <ressource code="information-accessibilite"></ressource>
      </div>
      <opq-case
        code="service-reference-intervention-domicile"
        v-model="sasServiceDeReference.interventionDomicile"
        optional
      ></opq-case>
      <opq-case
        code="service-reference-modalites"
        v-model="sasServiceDeReference.modalitesServiceReference"
      ></opq-case>
    </v-form>
  </div>
</template>

<script>
import CataloguesHelper from "@/mixins/CataloguesHelpers"
import EmploisReferences from "./EmploisReferences"
import FormHybrid from "@/mixins/FormHybrid"

export default {
  mixins: [CataloguesHelper, FormHybrid],
  components: { EmploisReferences },
  props: {
    sas: { type: Object },
  },
  data() {
    return {
      validsEmploisReferences: []
    }
  },
  methods: {
    estTypeEmploi(item, type) {
      return this.getCatalogueCodeById(2902, item.typeDEmploi) == type
    },
  },
  computed: {
    isValid() {
      return (
        this.valid && this.validsEmploisReferences.every((x) => x)
      )
    },
    sasServiceDeReference() {
      return this.sas.sasServiceDeReference
    },
    emploisReferencesActifs() {
      return this.sas?.emploisReferences?.filter((e) => e.serviceDeReferenceActif) ?? []
    },
    hasEmployeursInscrits() {
      return this.emploisReferencesActifs.length > 0
    },
    hasNombreEmployeursInscritsConforme() {
      return this.emploisReferencesActifs.length == this.nombreConformeEmploisReferencesSelectionnes
    },
    hasEmployeursAdmissibles() {
      return this.employeursAdmissibles.length > 0
    },
    employeursAdmissibles() {
      return (
        this.sas?.employeurs?.filter((e) => this.estTypeEmploi(e, "Pri") && !e.inactif) ?? []
      )
    },
    /**
     * Liste des emplois références admissibles à afficher dans le data-iterator
     */
    emploisReferencesAdmissibles() {
      return this.sas?.emploisReferences?.filter((e) => 
        this.employeursAdmissibles.map((emp) => emp.id).includes(e.sasCartesDAffaires))
        ?? []
    },
    /**
     * Le nombre conforme d'emploi référencés séléctionnés : 
     * Si il y a moins de cartes d'affaires disponibles que d'emplois reférencés déjà payés,
     * on peut et on doit sélectionner toutes ces cartes d'affaires
     */
    nombreConformeEmploisReferencesSelectionnes() {
      return this.employeursAdmissibles.length < this.sas.nombreEmploisReferencesInitial
        ? this.employeursAdmissibles.length
        : this.sas.nombreEmploisReferencesInitial
    }
  },
  watch: {
    validsEmploisReferences() {
      this.$emit("validation-changed", this.isValid)
    },
  },
}
</script>

<style></style>
